/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Kind of relationship between a portfolio and the portfolio it is linked to.
 * @export
 */
export const PortfolioLinkType = {
    LinkToMainCustody: 'LINK_TO_MAIN_CUSTODY'
} as const;
export type PortfolioLinkType = typeof PortfolioLinkType[keyof typeof PortfolioLinkType];


export function instanceOfPortfolioLinkType(value: any): boolean {
    for (const key in PortfolioLinkType) {
        if (Object.prototype.hasOwnProperty.call(PortfolioLinkType, key)) {
            if (PortfolioLinkType[key as keyof typeof PortfolioLinkType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioLinkTypeFromJSON(json: any): PortfolioLinkType {
    return PortfolioLinkTypeFromJSONTyped(json, false);
}

export function PortfolioLinkTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioLinkType {
    return json as PortfolioLinkType;
}

export function PortfolioLinkTypeToJSON(value?: PortfolioLinkType | null): any {
    return value as any;
}

export function PortfolioLinkTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PortfolioLinkType {
    return value as PortfolioLinkType;
}

